<ng-container *hasPermission="PermissionForStudents.MENTOR_VIEW">
  <div class="container-fluid mentors-page p-4 font-name">
    <div
      class="d-flex justify-content-between align-items-center flex-wrap ms-2 mb-3"
    >
      <div class="text-start">
        <h6>All Mentors</h6>
        <p class="mb-0">Book one-on-one sessions with industry experts</p>
      </div>
      <div class="text-end">
        <button class="btn-add2 btn-sm" (click)="goToSessionPage()">
          <mat-icon>calendar_month</mat-icon>My Sessions
        </button>
      </div>
    </div>

    <ng-container *ngIf="isMentor; else pageContent">
      <div class="app-spinner">
        <mat-spinner diameter="60"></mat-spinner>
      </div>
    </ng-container>

    <ng-template #pageContent>
      <ng-container *ngIf="mentors.length > 0; else noMentorsFound">
        <div class="mentors-grid">
          <div
            class="mentor-card"
            *ngFor="let mentor of mentors; let i = index"
          >
            <div class="mentor-header">
              <div class="avatar">
                {{ mentor.first_name[0] }}{{ mentor.last_name[0] }}
              </div>
              <div class="mentor-info">
                <h3>{{ mentor.first_name }} {{ mentor.last_name }}</h3>
                <h4 [matTooltip]="mentor.email">
                  {{
                    mentor.email.length > 16
                      ? (mentor.email | slice: 0 : 16) + "..."
                      : mentor.email
                  }}
                </h4>
              </div>
              <div class="rating-badge d-flex flex-column align-items-end">
                <span class="rating mb-1">
                  <i class="bi bi-star-fill star-icon"></i>
                  {{ mentor.rating }}</span
                >
                <span class="top-mentor">Top Mentor</span>
              </div>
            </div>

            <p class="experience">
              <i class="bi bi-briefcase me-2"></i>
              <span>{{ mentor.years_of_experience }} Years</span>
            </p>

            <p class="skills mt-2">
              <i class="bi bi-people me-2"></i>
              <span>{{ mentor.expertise }}</span>
            </p>

            <!-- <p class="reviews">
        <i class="bi bi-chat-square-heart me-2"></i>
        <span>Reviews</span>
      </p> for now we don't have this review fields in api's-->
            <hr />
            <p class="designation">
              {{ mentor.designation }} &#64; {{ mentor.company }}
            </p>

            <button
              class="btn-add"
              (click)="openBookSessionDialog(mentor)"
              *hasPermission="PermissionForStudents.MENTOR_BOOK"
            >
              Book Session
            </button>
          </div>
        </div>
        <div class="text-center mt-3" *ngIf="page < totalPages">
          <button class="btn-add" (click)="loadMore()" [disabled]="isMentor">
            <ng-container *ngIf="isMentor; else showBtnText">
              <span class="spinner-border spinner-border-sm"></span> Loading...
            </ng-container>
            <ng-template #showBtnText>Load More</ng-template>
          </button>
        </div>
      </ng-container>
      <ng-template #noMentorsFound>
        <p class="text-center">No Mentors Found</p>
      </ng-template>
    </ng-template>
  </div>
</ng-container>
